










































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MatterWorkMatterDto } from '@/models/matter-work/MatterWorkMatterDto';
import { MatterWorkTypeEnum, MatterWorkSearchTypeEnum } from '@/models/matter-work/MatterWorkTypeEnum';
import { sortBy } from 'lodash';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxButton, DxRadioGroup } from 'devextreme-vue';
import { DxTreeList, DxColumn, DxSearchPanel } from 'devextreme-vue/tree-list';
import { UserService } from '@/service/UserService';
import { UserSetting, UserSettingName, OrderingMethod } from '@/models/UserSetting';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { FilingTypeEnum, FilingTypeNameEnum, getFilingTypeName } from '@/models/matter/FilingTypeEnum';
import { BatchService } from '@/service/BatchService';
import _ from 'lodash';
import { getModule } from 'vuex-module-decorators';
import store from '@/store'
import MatterWorkModule from '@/store/MatterWorkModule'
import { AuditingService } from '@/service/AuditingService';
import { MatterOverageDNSDto } from '@/models/audit/MatterOverageDNSDto';
import { MatterOverageMilestoneDto } from '@/models/audit/MatterOverageMilestoneDto';
import { QuestelServicesClient } from '@questelservices/common';
import { MatterDetails, NavigationDetails, NavigationFlattened, NavigationItems } from '@/models/matter-work/NavigationDetails';

@Component({
  components: {
    DxButton,
    DxTreeList,
    DxColumn,
    DxSearchPanel,
    DxRadioGroup
  }
})
export default class MatterWorkNavigator extends Vue {
  @Prop()
  matterWorkId!: Guid;

  @Prop()
  phaseTypes!: Array<PhaseTypeDto>;

  @Prop()
  isAutoSkip!: boolean;

  // Flag for Auditing or Coding page functionality
  @Prop()
  pageType!: MatterWorkTypeEnum;

  @Prop()
  selectedMatterNav!: MatterWorkMatterDto

  codingType = MatterWorkTypeEnum.Coding;
  auditingType = MatterWorkTypeEnum.Auditing;  

  @Prop()
  userReviewedMode!: boolean;

  milestones: MatterOverageMilestoneDto[] = [];

  constructor() {
    super();
    this.batchService = new BatchService();
  }

  private matterTemplate(container: any, options: any): void {    
    const text = options.data.text;  
    
    if(this.pageType === MatterWorkTypeEnum.Coding && this.userReviewedMode === true) {
      const check: string = options.data.userReviewed && options.data.details.MatterId ? '&check;' : '';              
      container.innerHTML = `<span title='${text}' class='matter-work-matter-item ${options.data.userReviewed === false ? 'active' : ''} dx-template-wrapper'>${options.data.text} ${check}</span>`;        
    }
    else if(this.pageType === MatterWorkTypeEnum.Coding) {      
      const check: string = options.data.allConfirmed && options.data.details.MatterId ? '&check;' : '';
      container.innerHTML = `<span title='${text}' class='matter-work-matter-item ${options.data.allConfirmed === false ? 'active' : ''} dx-template-wrapper'>${text} ${check}</span>`;     
    }
    else if(this.pageType === MatterWorkTypeEnum.Auditing) {     
      const check: string = options.data.audited && options.data.details && options.data.details.MatterId ? '&check;' : '';
      container.innerHTML = `<span title='${text}' class='matter-work-matter-item ${options.data.audited === false ? 'active' : ''} dx-template-wrapper'>${text} ${check}</span>`;
    }        
  }

  private caseCount(): string {
    return `Case ${this.selectedMatterIndex + 1} of ${Object.keys(this.matterDetails).length}`;
  }

  private reviewedCount(): string {          
    if(this.pageType === MatterWorkTypeEnum.Coding && this.userReviewedMode === true) {
      const unReviewedMatterItemCount = Object.keys(_.pickBy(this.matterDetails, x => !x.UserReviewed)).length;  
      return `${unReviewedMatterItemCount} Unreviewed`;
    }
    else if(this.pageType === MatterWorkTypeEnum.Coding) {
      const unconfirmedMatterItemCount = Object.keys(_.pickBy(this.matterDetails, x=>!x.AllLineItemsConfirmed)).length;
      return `${unconfirmedMatterItemCount} Unconfirmed`;
    }
    else if(this.pageType === MatterWorkTypeEnum.Auditing) {
      const auditedMatterItemCount = Object.keys(_.pickBy(this.matterDetails, x=>x.Audited)).length;  
      return `${auditedMatterItemCount} Reviewed`;
    }

    console.error("No unreviewed/unconfirmed/reviewed count.");
    return "";
  }

  private get IsAutoSkip(){
    return this.isAutoSkip;
  }

  private get selectedMatterId(): Guid | null {
    return this.matterWorkModule.selectMatterId;
  }

  private get selectedMatter(): MatterWorkMatterDto | null {    
    return this.matterWorkModule.selectMatter;
  }

  private get selectedMatterIndex() {
    let uniqueNavItems = _.uniqBy(this.navItems.filter(x=>!x.isParent), x=>x.details!.MatterId);
    return uniqueNavItems.findIndex(x=>x.details!.MatterId === this.selectedMatterId);
  }

  private selectedItemId: string = '';
  private userService: UserService = new UserService();
  private auditingService: AuditingService = new AuditingService();
  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
  componentReady: boolean = false;
  caseDisplayOrder: string[] = ['Country', 'Agent', 'Phase', 'Filing Type'];
  private orderMethod: string = OrderingMethod.ByMatterName;
  matterWorkModule = getModule(MatterWorkModule, store);
  private matterDetails: MatterDetails = {};
  private navigationFlattened: Array<NavigationFlattened> = [];
  private navigationChangeTimeout: any;
  
  batchService: BatchService;
  private textSearchOptions: string[] = [MatterWorkSearchTypeEnum.Name, MatterWorkSearchTypeEnum.Description];
  private selectedTextSearchOption: string = MatterWorkSearchTypeEnum.Name;
  private shouldShowRelease: boolean = false;
  private isDisposed: boolean = false;

  private _searchText: string = '';
  get searchText() {
    return this._searchText;
  }
  set searchText(newValue: string) {    
    if(newValue === '') {      
      // The UI has not yet been updated (all nodes collapsed) when the search text has changed, so wait to re-select the current item until this has finished (hopefully)
      setTimeout(() => {
        this.scrollToId(this.selectedItemId);
      }, 250);
    }
    this._searchText = newValue;
  }

  created() {    
    this.loadData();
  }

  mounted() {
    this.$root.$on('updatenavmatters', this.updateNavMatters);
    this.$root.$on('matter-deleted', this.handleRemovingOfMatter);
    this.$root.$on('updatetargetmatter', this.updateTargetMatter);
  }

  handleRemovingOfMatter(matterId: any) {
    if(!_.some(this.navigationFlattened, x => x.MatterId != matterId)) { 
      if(this.pageType == MatterWorkTypeEnum.Auditing) {
        this.$router.push({name: 'auditing-work'});
      }
      else{
        this.$router.push({name: 'coding-work'});
      }
    }
    else {
      this.changeCase('next');
      this.updateMatterList(matterId);
    }
  }
  
  updateTargetMatter(clientMatterId: string, countryCode: string) {
    let matter = this.navigationFlattened.find(nf => nf.ClientMatterId == clientMatterId && nf.CountryCode == countryCode);
    if (matter !== undefined) {
      this.updateNavMatters(matter.MatterId);
    }
  }

  updateNavMatters(matterId: any) {    
    if(matterId == null || typeof(matterId) != "string") {
      matterId= this.selectedMatterId;
    }
    this.updateMatterList(matterId);
  }

  async loadData() {
    this.componentReady = false;
    let mattersData = await this.client.get<NavigationDetails>(`/api/MatterWorks/${this.matterWorkId}/navigation`);
    if(mattersData) {
      Object.assign(this.matterDetails, mattersData.Details);
      this.navigationFlattened = mattersData.NavigationItems;

      let matterWorkmatters = Object.values(this.matterDetails);
      if(this.pageType == MatterWorkTypeEnum.Auditing) {
        this.shouldShowRelease = !_.every(matterWorkmatters, x=>x.Audited === true);
      }
      else if(this.pageType == MatterWorkTypeEnum.Coding && this.userReviewedMode) {
        this.shouldShowRelease = !_.every(matterWorkmatters, x=>x.UserReviewed === true);
      }
      else {
        this.shouldShowRelease = !_.every(matterWorkmatters, x=>x.AllLineItemsConfirmed === true);
      }
    }

    if(this.navigationFlattened.length) {
      let activeBatchIds = await this.batchService.getActiveBatchIds(this.clientId);
      this.matterWorkModule.setActiveBatchIds(activeBatchIds);
    }

    if(this.pageType == this.auditingType) {
      await this.auditingService.getAllMatterOverageDNS(this.clientId)
      .then(result => {
          let matterOveragesDNS: MatterOverageDNSDto[] = result;
          matterOveragesDNS.forEach(x=> {
              let phase = this.phaseTypes.find(z=>z.PhaseTypeId ==x.PhaseTypeId);
              x.PhaseTypeName = phase ? phase.PhaseName : "";
          });
          this.matterWorkModule.setMatterOverageDNS(matterOveragesDNS)
      });
    }
    
    await this.refreshCaseDisplayOrder();
  }

  get clientId(): Guid {
    return Object.values(this.matterDetails)[0].ClientId;
  }

  private auditingHeaders: Array<NavigationItems> = [
      {
        text: 'Hard Overages',
        parentKey: null,
        itemKey: 'HardOverages',
        isParent: true,
        details: {} as any,
        level: -2
      },
      {
        text: 'Cap',
        parentKey: 'HardOverages',
        itemKey: 'HardOveragesCap',
        isParent: true,
        details: {} as any,
        level: -1
      },
      {
        text: 'Target',
        parentKey: 'HardOverages',
        itemKey: 'HardOveragesTarget',
        isParent: true,
        details: {} as any,
        level: -1
      },
      {
        text: 'Soft Overages',
        parentKey: null,
        itemKey: 'SoftOverages',
        isParent: true,
        details: {} as any,
        level: -2
      },
      {
        text: 'Cap',
        parentKey: 'SoftOverages',
        itemKey: 'SoftOveragesCap',
        isParent: true,
        details: {} as any,
        level: -1
      },
      {
        text: 'Target',
        parentKey: 'SoftOverages',
        itemKey: 'SoftOveragesTarget',
        isParent: true,
        details: {} as any,
        level: -1
      },
      {
        text: 'Infractions',
        parentKey: null,
        itemKey: 'Infractions',
        isParent: true,
        details: {} as any,
        level: -2
      },
      {
        text: 'Notes',
        parentKey: null,
        itemKey: 'Notes',
        isParent: true,
        details: {} as any,
        level: -2
      },
      {
        text: 'Internal Notes',
        parentKey: 'Notes',
        itemKey: 'InternalNotes',
        isParent: true,
        details: {} as any,
        level: -1
      },
      {
        text: 'Analysis Notes',
        parentKey: 'Notes',
        itemKey: 'ReportLanguage',
        isParent: true,
        details: {} as any,
        level: -1
      },
      {
        text: 'Do Not Send',
        parentKey: null,
        itemKey: 'DoNotSend',
        isParent: true,
        details: {} as any,
        level: -2
      },
      {
        text: 'Potential Issues',
        parentKey: null,
        itemKey: 'PotentialIssues',
        isParent: true,
        details: {} as any,
        level: -2
      },
      {
        text: 'Issues Removed',
        parentKey: null,
        itemKey: 'IssuesRemoved',
        isParent: true,
        details: {} as any,
        level: -2
      }
    ]

  async refreshCaseDisplayOrder(settings?: UserSetting[]) {
    if(this.isDisposed) {
      return;
    }
    
    if(!settings) {
      settings = await this.userService.getUserSettingsWithFilter({ reportName: 'ManualCoding', name: '' });
    }    

    const orderMethod: UserSetting = settings.filter(s => s.Name == UserSettingName.OrderingMethod)[0];      
    if(orderMethod) {
      this.orderMethod = orderMethod.Value;
    }    
    
    settings = settings.filter(s => s.Name !== UserSettingName.OrderingMethod);
    let sortedSettings = sortBy(settings, s => s.SortOrder);
    this.caseDisplayOrder = sortedSettings.map(s => s.Value);
    this.removeAllDataForRecalculation();
    this.navItems.length = 0;
    this.navItems = this.pageType == MatterWorkTypeEnum.Auditing ? this.createAuditingNavigationItems(): this.createNavigationItems();
    if(this.pageType == MatterWorkTypeEnum.Auditing) {
      this.updateAuditingHeaders();
    }
    else if(this.pageType == MatterWorkTypeEnum.Coding) {
      this.updateCodingHeaders(this.userReviewedMode);
    }
    this.updateParentStyling();
    this.componentReady = true;      

    // After component is ready, wait for tree list to render to select the first item
    await this.$nextTick();

    this.selectFirstMatter();
  }

  private selectFirstMatter() {
    let firstMatter: NavigationItems | undefined;
    
    if (this.pageType == MatterWorkTypeEnum.Auditing) {
      firstMatter = _.find(this.navItems, x=> !x.isParent && !x.audited)
    } else if (this.pageType == MatterWorkTypeEnum.Coding && this.userReviewedMode) {
      firstMatter = _.find(this.navItems, x=> !x.isParent && !x.userReviewed);
    } else {
      firstMatter = _.find(this.navItems, x=> !x.isParent && !x.allConfirmed);
    }
      
    // This is unlikely, but if no unconfirmed matters, then select the first one
    if (!firstMatter) {
      firstMatter = _.find(this.navItems, x=> !x.isParent);
    }    
    this.updateSelectedItem(firstMatter);   
  }

  private getTreeListNodeParents(childNode: DevExpress.ui.dxTreeListNode) : DevExpress.ui.dxTreeListNode[] {
    let node = childNode;
    let nodes = [];
    while(node && node.parent) {
      nodes.unshift(node.parent);
      node = node.parent;
    }
    return nodes;
  }

  private treeListSelectionChanged(e: any): void {    
    if(e.component.isReady()) {
      let selectedData: NavigationItems = e.selectedRowsData[0];
      let previousSelectedData = e.currentDeselectedRowKeys[0]

      if(!selectedData) {
        return;
      }

      if(selectedData.isParent) {
        e.component.deselectRows([selectedData.itemKey]);
        e.component.selectRows([previousSelectedData]);
        return;
      }

      // If the selection was changed programmatically (for example, via a keyboard shortcut or button click) the selectedItemId will already be set
      // If not (such as via a click on the navigator), then the selected item needs to be updated    
      if(selectedData.itemKey !== this.selectedItemId) {
        this.updateSelectedItem(selectedData);
      }

      // Collapse nodes after changing
      let dxTreeList = e.component as DevExpress.ui.dxTreeList;
      
      // Get old and  new parent nodes
      let oldSelectedNode = dxTreeList.getNodeByKey(e.currentDeselectedRowKeys[0]);
      let deselectedParentNodes = this.getTreeListNodeParents(oldSelectedNode);
      let newSelectedNode = dxTreeList.getNodeByKey(selectedData.itemKey);
      let newParentNodes = this.getTreeListNodeParents(newSelectedNode);

      // Filter to only parent nodes not in the new list
      let nodesToCollapse = deselectedParentNodes.filter(oldNode => !newParentNodes.some(newNode => newNode.key === oldNode.key));    
      
      // Collapse any old nodes, and expand all new ones
      nodesToCollapse.forEach(n => dxTreeList.collapseRow(n.key));
      newParentNodes.forEach(n => dxTreeList.expandRow(n.key));

      // Try to scroll to the newly selected id
      this.scrollToId(selectedData.itemKey);
    }
  }

  private textSearchOptionChanged(e: any): void {    
    const dxTreeList = ((this.$refs.dxTreeList as any).instance as DevExpress.ui.dxTreeList);
    dxTreeList.clearFilter();
  }

  private async scrollToId(id: string) {    
    if(this.$refs.dxTreeList) {
      // TODO: Fix issue with scrolling up to top
      await this.$nextTick();
      let dxTreeList = ((this.$refs.dxTreeList as any).instance as DevExpress.ui.dxTreeList);
      dxTreeList.navigateToRow(id);
    }
  }

  private updateSelectedItem(item: NavigationItems | undefined): void {     
    if(this.isDisposed) {
      return;
    }

    if (item && item.itemKey) {
      this.selectedItemId = item.itemKey;
      this.currentSelectedIndex = _.findIndex(_.cloneDeep(this.navItems.filter(x=> x.isParent == false)), ni => ni.itemKey == item.itemKey);
      var selectedMatter = _.clone(this.matterDetails[item.details!.MatterId]);
      selectedMatter.LineItems = [];
      this.matterWorkModule.setSelectedMatter(selectedMatter);
      this.matterWorkModule.setSelectedMatterId(item.details!.MatterId);
      this.scrollToId(item.itemKey);

      // if(this.navigationChangeTimeout) {
      //   clearTimeout(this.navigationChangeTimeout);
      // }
      // this.navigationChangeTimeout = setTimeout(()=>{
      //   this.client.get<ManualCodeInvoiceLineItemDto[]>(`/api/manualcoding/${item.details!.MatterId}/line-items`)
      //   .then(x=>{
      //     if(this.selectedMatter){
      //       this.selectedMatter.LineItems = x;
      //     }
      //   }).catch(x=> {
      //     if(this.selectedMatter) {
      //       this.selectedMatter.LineItems=[]
      //     }
            
      //   });
      // },250)      
    }
  }

  prevCase() {
    this.changeCase('prev',false);
  }
  nextCase() {
    this.changeCase('next',false);
  }
  prevActiveCase() {
    this.changeCase('prev', true);
  }
  nextActiveCase() {
    this.changeCase('next', true);
  }

  private currentSelectedIndex: number = -1;
  changeCase(direction: 'prev' | 'next', active: boolean = false, targetId: string | null = null) {
    let idToCheck = targetId || this.selectedItemId;   
    if(this.navItems && this.navItems.length) {
      let loopItems  = this.loopItems();

      if(this.pageType == MatterWorkTypeEnum.Auditing && active){
        loopItems = loopItems.filter(x=>!x.audited || x.itemKey == idToCheck);
      }
      else if(this.pageType == MatterWorkTypeEnum.Coding && this.userReviewedMode  && active) {
        loopItems = loopItems.filter(x=>!x.userReviewed || x.itemKey == idToCheck);
      }
      else if(this.pageType == MatterWorkTypeEnum.Coding && active){
        loopItems = loopItems.filter(x=>!x.allConfirmed || x.itemKey == idToCheck);
      }

      //try re-assigning if ever all are confirmed/audited/userreviewed
      if(loopItems.length <= 1) {
        loopItems  = this.loopItems();
      }

      //if items are still empty then stop
      if(loopItems.length <= 1) {
        return;
      }

      if(direction == 'prev') {
        loopItems = _.reverse(loopItems);
      }   

      let currentIndex = _.findIndex(loopItems, x=> x.itemKey == idToCheck);
      if(currentIndex < 0) {
        //it was removed :|_.cloneDeep(this.navItems.filter(x=> x.isParent == false)
        let addIndex = -1;
        if(direction == 'prev') {
          addIndex = 0;
        }

        let newKeyWithIndex = _.cloneDeep(this.navItems.filter(x=> x.isParent == false))[this.currentSelectedIndex+addIndex];
        if(newKeyWithIndex) {
          this.changeCase(direction,active,newKeyWithIndex.itemKey);
          return;
        }
      }
      let nextIndex=currentIndex+1;
      let nextNav: NavigationItems = loopItems[nextIndex%loopItems.length];
      if(nextNav) {
        this.updateSelectedItem(nextNav);
      }
    }
  }

  private loopItems() {
    if(this.navItems != null && this.navItems.length) {
      if(this.selectedTextSearchOption == MatterWorkSearchTypeEnum.Name && this._searchText) {
        return this.navItems.filter(x=> x.isParent == false && x.text.toLowerCase().includes(this._searchText.toLowerCase()));
      }

      if(this.selectedTextSearchOption == MatterWorkSearchTypeEnum.Description && this._searchText) {
        return this.navItems.filter(x=> x.isParent == false 
                                        && x.matterWork 
                                        && x.matterWork.LineItemDescriptionList 
                                        && x.matterWork.LineItemDescriptionList.toLowerCase().includes(this._searchText.toLowerCase()));
      }
      
      return this.navItems.filter(x=> x.isParent == false);
    }
    return [];
  }
  
  confirmAllMatters() {
    if (this.pageType === MatterWorkTypeEnum.Auditing && this.selectedMatter != null) {
      if (!this.selectedMatter.Audited) {
        this.$emit('auditMatter');
      } 
      this.nextActiveCase();
    } else if (this.pageType === MatterWorkTypeEnum.Coding && this.selectedMatter != null) {
        
      if (this.userReviewedMode && !this.selectedMatter.UserReviewed) {
        this.$emit('confirmAll');
      } else if (!this.userReviewedMode && !this.selectedMatter.AllLineItemsConfirmed) {
        this.$emit('confirmAll');
      }
      this.nextActiveCase();
      
    }
  }

  async updateMatterList(matterId: Guid) {
    if(this.isDisposed) {
      return;
    }

    let updatedMatters = await this.client.get<NavigationDetails>( `/api/MatterWorks/${this.matterWorkId}/navigation?matterId=${matterId}`);
    this.matterDetails = Object.assign({}, this.matterDetails ,updatedMatters.Details);
    _.remove(this.navigationFlattened, x=>x.MatterId == matterId);
    this.mergeArrays(this.navigationFlattened,updatedMatters.NavigationItems)
    if(this.pageType == MatterWorkTypeEnum.Auditing) {
      this.removeUpdatedMatter(matterId);
      var newNavItems = this.createAuditingNavigationItems(updatedMatters.NavigationItems);
      this.navItems.length = 0;
      this.navItems = newNavItems;
      this.updateAuditingHeaders();
    }
    else{
      var items = this.createNavigationItems();
      this.navItems.length = 0;
      this.navItems = items;
      this.updateCodingHeaders(this.userReviewedMode);
    }
    this.updateParentStyling();    
  }

  removeUpdatedMatter(matterId : Guid) {
    _.remove(this.navItems, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    _.remove(this.capHardOverages, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.capHardOverages);
    _.remove(this.targetHardOverages, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.targetHardOverages);
    _.remove(this.capSoftOverages, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
     this.removeGroupingsWithNoMember(this.capSoftOverages);
    _.remove(this.targetSoftOverages, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.targetSoftOverages);
    _.remove(this.infractions, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.infractions);
    _.remove(this.reportLanguage, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.reportLanguage);
    _.remove(this.internalNotes, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.internalNotes);
    _.remove(this.doNotSend, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.doNotSend);    
    _.remove(this.potentialIssues, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.potentialIssues);    
    _.remove(this.issuesRemoved, x => x.details && x.details.MatterId && x.details.MatterId == matterId);
    this.removeGroupingsWithNoMember(this.issuesRemoved);
  }

  removeAllDataForRecalculation() {
    this.capHardOverages.length = 0;
    this.targetHardOverages.length = 0;
    this.capSoftOverages.length = 0;
    this.targetSoftOverages.length = 0;
    this.infractions.length = 0;
    this.reportLanguage.length = 0;
    this.internalNotes.length = 0;
    this.doNotSend.length = 0;
    this.potentialIssues.length = 0;
    this.issuesRemoved.length = 0;
  }

  removeGroupingsWithNoMember(itemList: Array<NavigationItems>)
  {
    if(itemList && itemList.length > 0) {
      var groupings = _.cloneDeep(itemList).filter(x => !this.auditingHeaders.map(y => y.itemKey).includes(x.itemKey) 
                                            && x.isParent && x.level != null && (x.details && !x.details.MatterId));
      groupings = _.orderBy(groupings, ['level'],['desc']);   
      
      groupings.forEach(x => {
        var ind = _.findIndex(itemList, item => item.parentKey == x.itemKey)
        if(ind == -1) {
          _.remove(itemList, item => item.itemKey == x.itemKey);
        }
      });

    }
  }
  confirmAuditMatter(matterId: Guid, setBool: boolean) {
    if(this.pageType == MatterWorkTypeEnum.Auditing) {
      var items = this.navItems.filter(x=> !x.isParent && x.details!.MatterId == matterId)
      var navFlattend= this.navigationFlattened.filter(x=>x.MatterId == matterId);
      navFlattend.forEach(x=>{
        x.IsAudited = setBool;
      });
      items.forEach(x=>{ 
          x.audited = setBool; 
          x.details!.IsAudited = setBool;
      });
      this.matterDetails[matterId].Audited = setBool;
      this.updateAuditingHeaders();
      if(this.selectedMatter!.MatterId === matterId) {
        this.nextActiveCase();
      }
    }
    else if(this.pageType == MatterWorkTypeEnum.Coding) {
      if(this.userReviewedMode) {
        this.navItems.filter(x=> !x.isParent && x.details!.MatterId === matterId).forEach(x=>{ x.userReviewed = setBool; });
        this.matterDetails[matterId].UserReviewed = setBool;
        this.selectedMatter!.UserReviewed = setBool;
      }
      else {
        if(this.pageType == MatterWorkTypeEnum.Coding) {
          this.navItems.filter(x=> !x.isParent && x.details!.MatterId === matterId).forEach(x=>{ x.allConfirmed = setBool; });
          this.matterDetails[matterId].AllLineItemsConfirmed = setBool;
          this.selectedMatter!.AllLineItemsConfirmed = setBool;
        }
      }
      this.updateCodingHeaders(this.userReviewedMode);
    }
    
    this.updateParentStyling();
  }
  
  beforeDestroy() {
    this.matterWorkModule.setMatterOverageDNS([]);
    this.matterWorkModule.setActiveBatchIds([]);
    this.matterWorkModule.setSelectedMatterId(null);
    this.matterWorkModule.setSelectedMatter(null);
    this.capHardOverages.length = 0;
    this.capSoftOverages.length = 0;
    this.targetHardOverages.length = 0;
    this.targetSoftOverages.length = 0;
    this.reportLanguage.length = 0;
    this.internalNotes.length = 0;
    this.infractions.length = 0;
    this.doNotSend.length = 0;
    this.potentialIssues.length = 0;
    this.issuesRemoved.length = 0;
    this.navigationFlattened.length = 0;
    this.navItems.length = 0;
    this.$root.$off('updatenavmatters', this.updateNavMatters)
    this.$root.$off('matter-deleted', this.handleRemovingOfMatter)
    this.$root.$off('updatetargetmatter', this.updateTargetMatter);
    this.removeMatterDetails();
    this.detachHandlers();
    this.componentReady=false;
  }

  detachHandlers() {
    let dxTreeList = this.$refs.dxTreeList as any;
    if(dxTreeList) {
      let treeListInstance = dxTreeList.instance as DevExpress.ui.dxTreeList;
      treeListInstance.off("selectionChanged");
      treeListInstance.option("onSelectionChanged", undefined);
      treeListInstance.dispose();
    }
    this.isDisposed = true;
  }

  removeMatterDetails() {
    for(var key in this.matterDetails) {
      if(this.matterDetails.hasOwnProperty(key)) {
        delete this.matterDetails[key];
      }
    }
  }

  private get getNavItems(): Array<NavigationItems> {
    return this.navItems;
  }

  private navItems: Array<NavigationItems> = [];

  private capHardOverages: Array<NavigationItems> = [];
  private targetHardOverages: Array<NavigationItems> = [];
  private capSoftOverages: Array<NavigationItems> = [];
  private targetSoftOverages: Array<NavigationItems> = [];
  private infractions: Array<NavigationItems> = [];
  private internalNotes: Array<NavigationItems> = [];
  private reportLanguage: Array<NavigationItems> = [];
  private doNotSend: Array<NavigationItems> = [];
  private potentialIssues: Array<NavigationItems> = [];
  private issuesRemoved: Array<NavigationItems> = [];

  private createAuditingNavigationItems(updatedMatter: NavigationFlattened[] | undefined = undefined) {    
    var navFlattend = updatedMatter ? updatedMatter : this.navigationFlattened;
    let auditingNavigation: Array<NavigationItems> = [];
    var capHardOveragesTemp: Array<NavigationItems> = [];
    var targetHardOveragesTemp: Array<NavigationItems> = [];
    var capSoftOveragesTemp: Array<NavigationItems> = [];
    var targetSoftOveragesTemp: Array<NavigationItems> = [];
    var infractionsTemp: Array<NavigationItems> = [];
    var internalNotesTemp: Array<NavigationItems> = [];
    var reportLanguageTemp: Array<NavigationItems> = [];
    var doNotSendTemp: Array<NavigationItems> = [];
    var potentialIssuesTemp: Array<NavigationItems> = [];
    var issuesRemovedTemp: Array<NavigationItems> = [];

    
    capHardOveragesTemp = this.createNavigationItems(_.filter(navFlattend, x=> x.HardOverage == true && x.OverageType == "Cap" && x.DoNotSend != true));
    capHardOveragesTemp.forEach(x=>{
      x.parentKey = "HardOveragesCap"+ (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "HardOveragesCap"+x.itemKey;
    });

    targetHardOveragesTemp = this.createNavigationItems(_.filter(navFlattend, x=> x.HardOverage == true && x.OverageType == "Target" && x.DoNotSend != true));
    targetHardOveragesTemp.forEach(x=>{
      x.parentKey = "HardOveragesTarget"+ (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "HardOveragesTarget"+x.itemKey;
    });

    capSoftOveragesTemp = this.createNavigationItems(_.filter(navFlattend, x=> x.SoftOverage == true && x.OverageType == "Cap" && x.DoNotSend != true));
    capSoftOveragesTemp.forEach(x=>{
      x.parentKey = "SoftOveragesCap"+ (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "SoftOveragesCap"+x.itemKey;
    });

    targetSoftOveragesTemp = this.createNavigationItems(_.filter(navFlattend, x=> x.SoftOverage == true && x.OverageType == "Target" && x.DoNotSend != true));
    targetSoftOveragesTemp.forEach(x=>{
      x.parentKey = "SoftOveragesTarget"+ (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "SoftOveragesTarget"+x.itemKey;
    });
    
    infractionsTemp = this.createNavigationItems(_.filter(navFlattend, x=> x.HasInfraction == true));
    infractionsTemp.forEach(x=>{
      x.parentKey = "Infractions"+ (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "Infractions"+x.itemKey;
    });

      internalNotesTemp = this.createNavigationItems(_.filter(navFlattend,x=> x.HasInternalNotes == true))
      internalNotesTemp.forEach(x=>{
        x.parentKey = "InternalNotes"+ (x.parentKey == null ? '' : x.parentKey);
        x.itemKey = "InternalNotes"+x.itemKey;
      });

      reportLanguageTemp = this.createNavigationItems(_.filter(navFlattend,x=> x.HasReportLanguage == true))
      reportLanguageTemp.forEach(x=>{
        x.parentKey = "ReportLanguage"+ (x.parentKey == null ? '' : x.parentKey);
        x.itemKey = "ReportLanguage"+x.itemKey;
      });

    doNotSendTemp = this.createNavigationItems(_.filter(navFlattend, x=> x.DoNotSend == true && (x.SoftOverage == true || x.HardOverage == true)));
    doNotSendTemp.forEach(x=>{
      x.parentKey = "DoNotSend" + (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "DoNotSend"+ x.itemKey;
    });

    potentialIssuesTemp = this.createAnalysisIssueItems(_.filter(navFlattend, x=> x.HasAnalysisIssue == true));
    potentialIssuesTemp.forEach(x=> {
      x.parentKey = "PotentialIssues" + (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "PotentialIssues"+ x.itemKey;
    });

    if(capHardOveragesTemp.length > 0) {
      this.capHardOverages = this.mergeAndReorderNavigationItems(this.capHardOverages, capHardOveragesTemp);
    }
    if(targetHardOveragesTemp.length > 0) {
      this.targetHardOverages = this.mergeAndReorderNavigationItems(this.targetHardOverages, targetHardOveragesTemp);
    }
    if(capSoftOveragesTemp.length > 0) {
      this.capSoftOverages = this.mergeAndReorderNavigationItems(this.capSoftOverages, capSoftOveragesTemp);
    }
    if(targetSoftOveragesTemp.length > 0) {
      this.targetSoftOverages = this.mergeAndReorderNavigationItems(this.targetSoftOverages, targetSoftOveragesTemp);
    }
    if(infractionsTemp.length > 0) {
      this.infractions = this.mergeAndReorderNavigationItems(this.infractions, infractionsTemp);
    }
    if(internalNotesTemp.length > 0) {
      this.internalNotes = this.mergeAndReorderNavigationItems(this.internalNotes, internalNotesTemp);
    }
    if(reportLanguageTemp.length > 0) {
      this.reportLanguage = this.mergeAndReorderNavigationItems(this.reportLanguage, reportLanguageTemp);
    }

    if(doNotSendTemp.length > 0) {
      this.doNotSend = this.mergeAndReorderNavigationItems(this.doNotSend, doNotSendTemp);
    }
    if(potentialIssuesTemp.length > 0) {
      this.potentialIssues = this.mergeAndReorderNavigationItems(this.potentialIssues, potentialIssuesTemp);
    }

    this.mergeArrays(auditingNavigation, this.auditingHeaders);
    this.mergeArrays(auditingNavigation, this.capHardOverages);
    this.mergeArrays(auditingNavigation, this.targetHardOverages);
    this.mergeArrays(auditingNavigation, this.capSoftOverages);
    this.mergeArrays(auditingNavigation, this.targetSoftOverages);
    this.mergeArrays(auditingNavigation, this.infractions);
    this.mergeArrays(auditingNavigation, this.internalNotes);
    this.mergeArrays(auditingNavigation, this.reportLanguage);
    this.mergeArrays(auditingNavigation, this.doNotSend);
    this.mergeArrays(auditingNavigation, this.potentialIssues);

    let mattersWithIssues = _.uniq(auditingNavigation.filter(x=>!x.isParent).map(x=>x.details!.MatterId));

    var issuesRemovedTemp : Array<NavigationItems> = [];
    issuesRemovedTemp = this.createNavigationItems(navFlattend.filter(x=> mattersWithIssues.indexOf(x.MatterId) < 0));
    issuesRemovedTemp.forEach(x=>{
      x.parentKey = "IssuesRemoved"+ (x.parentKey == null ? '' : x.parentKey);
      x.itemKey = "IssuesRemoved"+x.itemKey;
    });

    if(issuesRemovedTemp.length > 0) {
      this.issuesRemoved = this.mergeAndReorderNavigationItems(this.issuesRemoved, issuesRemovedTemp);
    }
    this.mergeArrays(auditingNavigation, this.issuesRemoved);
    auditingNavigation = _.uniqBy(auditingNavigation, i => i.itemKey)

    return auditingNavigation;
  }

  mergeAndReorderNavigationItems(target: Array<NavigationItems>, source: Array<NavigationItems>) {
      var result: Array<NavigationItems> = []; 
      var parentNavs = _.remove(target, x => x.isParent)
      var sourceParentNavs = _.remove(source, x => x.isParent)
      var parentNavResult : Array<NavigationItems> = []; 
      var itemNavResult: Array<NavigationItems> = []; 
      if((parentNavs && parentNavs.length > 0) || 
        (sourceParentNavs && sourceParentNavs.length > 0)) {
        sourceParentNavs.forEach(x =>
        {
          var isInTarget = _.findIndex(parentNavs, y => y.itemKey == x.itemKey);
          if(isInTarget == -1) {
            parentNavs.push(x);
          }
        });
        parentNavResult = this.sortByDisplayOrder(parentNavs);

        let lowestParentLevel = _.maxBy(parentNavResult.map(x=> x.level)) || 0;
        let parentInDeepestLevel = parentNavResult.filter(x => x.level == lowestParentLevel);
        this.mergeArrays(target, source);
        parentInDeepestLevel.forEach(element => {
          let items = this.sortOrder(_.filter(target, x => x.parentKey == element.itemKey));

          this.mergeArrays(itemNavResult, items);
        });

        this.mergeArrays(result, parentNavResult)
        this.mergeArrays(result, itemNavResult)
      }
      else{
        this.mergeArrays(target, source)

        target = this.sortOrder(target);
        this.mergeArrays(result, target)
      }
 
      result = _.uniqBy(result, i => i.itemKey)
      return result;
  }

  sortByDisplayOrder(items: Array<NavigationItems>| []) {
    let temp : Array<NavigationItems> = []; 

    if(items.length == 0){
      return [];
    }

    let maxLevelItem = _.minBy(items, x => x.level);
    let maxLevel = maxLevelItem ? maxLevelItem.level : 0;
    let maxCaseType = maxLevelItem ? maxLevelItem.caseType : '';
    let maxLevelItems = _.filter(items, x => x.level == maxLevel);

    if(maxCaseType == 'Phase') {
      temp = this.sortByPhase(maxLevelItems);
    }
    else if(maxCaseType =='Filing Type') {
      temp = this.sortByFilingType(maxLevelItems);
    }
    else {
      temp = _.sortBy(maxLevelItems, ['text']);
    }
    
    let tempItems = _.cloneDeep(temp);
    tempItems.forEach(x => {
      var nextLevelItems = items.filter(y => y.parentKey && y.parentKey.includes(x.itemKey));

      this.mergeArrays(temp, this.sortByDisplayOrder(nextLevelItems));
    });

    return temp;
  }

  private updateCodingHeaders(isUserReviewMode: boolean) {
    var parentHeaderLevel = _.minBy(this.navItems, item => item.level);

    if(parentHeaderLevel && parentHeaderLevel.level != undefined) {
      var parentHeaders = _.filter(this.navItems, item => item.isParent && item.level == (parentHeaderLevel ? parentHeaderLevel.level : 0));

      parentHeaders.forEach(pHeader => {
        var members = _.filter(this.navItems, item => !item.isParent && item.itemKey.includes(pHeader.itemKey))
        var count = members.length;
        var confirmedCount = isUserReviewMode ? _.filter(members, item => item.userReviewed).length : _.filter(members, item => item.allConfirmed).length;

        pHeader.text = `${pHeader.itemKey} ${confirmedCount}/${count}`;
      });
    }
  }

  private updateAuditingHeaders() {
    if(this.pageType != MatterWorkTypeEnum.Auditing) {
      return;
    }

    let hardOverageHeader = this.navItems.find(x=>x.itemKey=='HardOverages');
    let hardOverageCount = _.uniq(this.capHardOverages.concat(this.targetHardOverages).filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;
    let hardOverageAuditedCount = _.uniq(this.capHardOverages.concat(this.targetHardOverages).filter(x=>x.audited && !x.isParent).map(x=>x.details!.MatterId)).length;
    hardOverageHeader!.text=`Hard Overages ${hardOverageAuditedCount}/${hardOverageCount}`;

    let softOverageHeader = this.navItems.find(x=>x.itemKey=='SoftOverages');
    let softOverageCount = _.uniq(this.capSoftOverages.concat(this.targetSoftOverages).filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;
    let softOverageAuditedCount = _.uniq(this.capSoftOverages.concat(this.targetSoftOverages).filter(x=>x.audited && !x.isParent).map(x=>x.details!.MatterId)).length;
    softOverageHeader!.text = `Soft Overages ${softOverageAuditedCount}/${softOverageCount}`;

    let notesHeader = this.navItems.find(x=>x.itemKey=='Notes');
    let notesCount = _.uniq(this.internalNotes.concat(this.reportLanguage).filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;    
    let notesAuditedCount = _.uniq(this.internalNotes.concat(this.reportLanguage).filter(x=>x.audited  && !x.isParent).map(x=>x.details!.MatterId)).length;
    notesHeader!.text = `Notes ${notesAuditedCount}/${notesCount}`;

    let infractionsHeader = this.navItems.find(x=>x.itemKey=='Infractions');
    let infractionsCount = _.uniq(this.infractions.filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;
    let infractionsAuditedCount = _.uniq(this.infractions.filter(x=>x.audited && !x.isParent).map(x=>x.details!.MatterId)).length;
    infractionsHeader!.text= `Infractions ${infractionsAuditedCount}/${infractionsCount}`;

    let doNotSendHeader = this.navItems.find(x=>x.itemKey=='DoNotSend');
    let doNotSendCount = _.uniq(this.doNotSend.filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;
    let doNotSendAuditedCount = _.uniq(this.doNotSend.filter(x=>x.audited && !x.isParent).map(x=>x.details!.MatterId)).length;
    doNotSendHeader!.text = `Do Not Send ${doNotSendAuditedCount}/${doNotSendCount}`;
    
    let potentialIssuesHeader = this.navItems.find(x=>x.itemKey=='PotentialIssues');
    let potentialIssuesCount = _.uniq(this.potentialIssues.filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;
    let potentialIssuesAuditedCount = _.uniq(this.potentialIssues.filter(x=>x.audited && !x.isParent).map(x=>x.details!.MatterId)).length;
    potentialIssuesHeader!.text = `Potential Issues ${potentialIssuesAuditedCount}/${potentialIssuesCount}`;

    let issuesRemovedHeader = this.navItems.find(x=>x.itemKey=='IssuesRemoved');
    let issueRemovedCount = _.uniq(this.issuesRemoved.filter(x=>!x.isParent).map(x=>x.details!.MatterId)).length;
    let issueRemovedAuditedCount = _.uniq(this.issuesRemoved.filter(x=>x.audited && !x.isParent).map(x=>x.details!.MatterId)).length;
    issuesRemovedHeader!.text = `Issues Removed ${issueRemovedAuditedCount}/${issueRemovedCount}`;
  }

  private updateParentStyling() {
    let parents = _.sortBy(_.uniq(_.filter(this.navItems, x => x.isParent)), x=> x.level! * -1);
    parents.forEach(x => {
      if(this.pageType == MatterWorkTypeEnum.Auditing)  {
        x.audited = !this.navItems.some(z => z.parentKey == x.itemKey && z.audited != true);
      }
      else if(this.pageType == MatterWorkTypeEnum.Coding && this.userReviewedMode) {
        x.userReviewed = !this.navItems.some(z => z.parentKey == x.itemKey && z.userReviewed != true);
      }
      else {
        x.allConfirmed = !this.navItems.some(z => z.parentKey == x.itemKey && z.allConfirmed != true);
      }
    });
  }

  private createNavigationItems(items?: Array<NavigationFlattened>) {
    if(items == null) {
      items = this.navigationFlattened
    }
    //create a plain list instead of nested arrays to easily loop through.
    //use parentkeys to create hierarchy in dxtreelist
    let navigationItems: Array<NavigationItems> = [];
    let headers: Array<any> = [];
    //check for caseDisplays
    if(this.caseDisplayOrder.length) {
      //sort case displays to be used for keycombinations for parentKeys, 
      //get corresponding casedisplay object keys Agent -> Agent, Phase -> Phase, Filing Type -> FilingTypeId, Country -> CountryCode
      let sortedCase = _.sortBy(this.caseDisplayOrder.map(x=> {return { caseType: x, key: this.getCaseOrderKey(x)};}),['key']);
      //go through the flattened list and get the Case Display value combinations for item
      let groupedNavigation = _.groupBy(items, (details) =>{
            let header: any = {};
            let itemKey = sortedCase.map(x=> {
              let value: string = details[x.key];
              if(x.key == "FilingTypeId") {
                value = getFilingTypeName(details[x.key]);
              }
              header[x.caseType] = value;
              return value;
            }).join('');
            header['parentId'] = itemKey;
            headers.push(header);
            return itemKey;
        })

      //make sure headers are unique
      let uniqueHeaders = _.uniqBy(headers,(x)=> x['parentId']);
      let parentNavs: Array<NavigationItems> = [];
      let itemNavs: Array<NavigationItems> = [];

      //loop through the unique headers and start creating the nav items
      _.forEach(uniqueHeaders, header=> {
          let itemKey: string = '';
          var agentCaseOrder = this.caseDisplayOrder.find(x => x == "Agent");
          var phaseCaseOrder = this.caseDisplayOrder.find(x => x == "Phase");
          this.caseDisplayOrder.forEach((x,index,arr)=> {
          
          let item: NavigationItems = {
            text: header[x],
            parentKey: index == 0 ? null : itemKey,
            itemKey: index == arr.length - 1 ? header['parentId'] : itemKey+header[x],
            isParent: true,
            details: {} as any,
            caseType: x,
            level: index,
            allConfirmed: true,
            audited: true,
            userReviewed: true,
          }
          itemKey = itemKey+header[x];
          parentNavs.push(item);
        });

        let navItems = _.sortBy(_.uniqBy(groupedNavigation[header['parentId']], (x)=> header['parentId']+x.MatterId),['text']);
        _.forEach(_.cloneDeep(navItems),(x)=> {
          var agentValue = header[agentCaseOrder || ''];
          var phaseValue = header[phaseCaseOrder || ''];

          if(agentValue && phaseValue) {
            x.LineItemTotalsService = x.NavigationTotal.LineItemTotalsService;
            x.LineItemTotals = x.NavigationTotal.LineItemTotal
          }
          else if(agentValue) {
            x.LineItemTotalsService = x.NavigationTotal.OverallAgentServiceTotal;
            x.LineItemTotals = x.NavigationTotal.OverallAgentTotal;
          }
          else if(phaseValue) {
            x.LineItemTotalsService = x.NavigationTotal.OverallPhaseServiceTotal;
            x.LineItemTotals = x.NavigationTotal.OverallPhaseTotal;
          }
          else {
            x.LineItemTotalsService = x.NavigationTotal.MatterServiceTotal;
            x.LineItemTotals = x.NavigationTotal.MatterTotal;
          }

          let itemDetails: NavigationItems = {
            text: x.ClientMatterId,
            parentKey: header['parentId'],
            itemKey:  header['parentId']+x.MatterId,
            isParent: false,
            details: x,
            allConfirmed: this.matterDetails[x.MatterId].AllLineItemsConfirmed,
            userReviewed: this.matterDetails[x.MatterId].UserReviewed,
            audited: x.IsAudited ? true : false,
            level: null,
            matterWork: this.matterDetails[x.MatterId]
          }
          itemNavs.push(itemDetails);
        });
      });

      parentNavs = this.sortHeaders(_.uniqBy(parentNavs,(x)=> x.text+x.itemKey), null);
      //get final parent and loop to sort children
      parentNavs.filter(x=>x.level == this.caseDisplayOrder.length - 1).forEach(x=> {
        let forSort = _.remove(itemNavs, z=> z.parentKey == x.itemKey);
        forSort = this.sortOrder(forSort);
        this.mergeArrays(itemNavs, forSort);
      })
      this.mergeArrays(navigationItems, parentNavs)
      this.mergeArrays(navigationItems, itemNavs)
    }
    else {
      let unGrouped = _.sortBy(_.uniqBy(items, x => x.MatterId), ['ClientMatterId']);
      _.forEach(_.cloneDeep(unGrouped), x=> {
        x.LineItemTotalsService = x.NavigationTotal.MatterServiceTotal;
        x.LineItemTotals = x.NavigationTotal.MatterTotal;

        let itemDetails: NavigationItems = {
            text: x.ClientMatterId,
            parentKey: null,
            itemKey:  x.MatterId,
            isParent: false,
            details: x,
            allConfirmed: this.matterDetails[x.MatterId].AllLineItemsConfirmed,
            userReviewed: this.matterDetails[x.MatterId].UserReviewed,
            audited: x.IsAudited ? true : false,
            level: 0,
            matterWork: this.matterDetails[x.MatterId]
          }
          navigationItems.push(itemDetails);
      });
      navigationItems = this.sortOrder(navigationItems);
    }
    return navigationItems;
  }

  createAnalysisIssueItems(items?: Array<NavigationFlattened>) {
    if(items == null || items == undefined) {
      items = this.navigationFlattened
    }

    // create sub header for each rule type
    let analysisTriggerRules = (_.flatten(items.map(i => i.AnalysisIssues)));
    let uniqueRules = _.sortBy(_.uniqBy(analysisTriggerRules, ai => ai.AnalysisTriggerRuleId), r => r.RuleName);

    let parentNavs: Array<NavigationItems> = [];
    _.forEach(uniqueRules, r => {
      parentNavs.unshift({
        text: r.RuleName,
        parentKey: '',
        itemKey: r.AnalysisTriggerRuleId,
        isParent: true,
        details: {} as any,
        level: -1
      })
    });    

    // for each rule type, create the subtree
    let navItems: Array<NavigationItems> = [];
    for (let navItem of parentNavs) {
      navItems.unshift(navItem);
      let subItems = items.filter(i => i.AnalysisIssues.some(ai => ai.AnalysisTriggerRuleId == navItem.itemKey))
      let childNavItems = this.createNavigationItems(subItems);
      childNavItems.forEach(x => {
        x.parentKey = navItem.itemKey + (x.parentKey == null ? '' : x.parentKey);
        x.itemKey = navItem.itemKey + x.itemKey;
      });
      this.mergeArrays(navItems, childNavItems);
    }

    return navItems;
  }

  private sortHeaders(headerItems: Array<NavigationItems>, parentKey: string | null) {
    let itemsToSort = _.remove(headerItems,x=>x.parentKey == parentKey);
    if(itemsToSort.length == 0) {
      return [];
    }
    let caseType = itemsToSort[0].caseType;
    let level = itemsToSort[0].level;
    let sorted: Array<NavigationItems> = [];

    if(caseType == 'Phase') {
        itemsToSort = this.sortByPhase(itemsToSort);
      }
      else if(caseType =='Filing Type') {
        itemsToSort = this.sortByFilingType(itemsToSort);
      }
      else {
        itemsToSort = _.sortBy(itemsToSort, ['text']);
      }
      this.mergeArrays(sorted,itemsToSort)

      if(level! < this.caseDisplayOrder.length) {
        _.forEach(itemsToSort, x=>{
          var children = this.sortHeaders(headerItems, x.itemKey);
          this.mergeArrays(sorted,children)
        });
      }
    return sorted;
  }

  private sortByPhase(headerItems: Array<NavigationItems>) {
    let sorted = _.sortBy(headerItems.map(x=> { 
      let phase = this.phaseTypes.find(z=>z.PhaseName == x.text);
      let phaseSort = phase != null ? phase.PhaseOrder : this.phaseTypes.length+1
      return {item: x, order: phaseSort}
    }),['order']).map(x=> x.item);
    return sorted;
  }

  private sortByFilingType(headerItems: Array<NavigationItems>) {
    let filingTypeEnum = FilingTypeEnum as any
    let filingTypeNameEnum = FilingTypeNameEnum as any
    let sorted = _.sortBy(headerItems.map(x=> { 
      let sort: number = filingTypeEnum[filingTypeNameEnum[x.text]]
      return {item: x, order: sort}
    }),['order']).map(x=> x.item);
    return sorted;
  }

  private sortOrder(navItems: Array<NavigationItems>) {
    switch(this.orderMethod) {
      case OrderingMethod.ByMatterName:
        return sortBy(navItems, r => r.text);
      case OrderingMethod.ByServiceCost:
        return _.orderBy(navItems, ['details.LineItemTotalsService', 'text'], ['desc', 'asc']);
      case OrderingMethod.ByTotalCost:
        return _.orderBy(navItems, ['details.LineItemTotals', 'text'], ['desc', 'asc']);
      default:
        return navItems;
    }    
  }

  //for final parent key generation
  private getCaseOrderKey(caseOrder: string) {
    let key: string;
    switch(caseOrder) {
      case 'Agent':
        key = 'Agent';
        break;
      case 'Phase':
        key = 'Phase';
        break;
      case 'Country':
        key = 'CountryCode';
        break;
      case 'Filing Type':
        key = 'FilingTypeId';
        break;
      default:
        key = '';
        break;
    }
    return key;
  }

  //prevents creation of new array, instead of concat.
  private mergeArrays(target: Array<any>, source: Array<any>) {
    source.forEach(x=>{
      target.push(x);
    });
  }

  checkForRelease() {
    let matterWorkmatters = Object.values(this.matterDetails);
    let forRelease: boolean = false;
    if(this.pageType == MatterWorkTypeEnum.Auditing) {
      forRelease = _.every(matterWorkmatters, x=>x.Audited === true);
    }
    else if(this.pageType === MatterWorkTypeEnum.Coding && this.userReviewedMode) {
      forRelease = _.every(matterWorkmatters, x=>x.UserReviewed === true);
    }
    else {
      forRelease = _.every(matterWorkmatters, x=>x.AllLineItemsConfirmed === true);
    }
    return forRelease && this.shouldShowRelease;
  }

}
